// @ts-nocheck 96888a61
import * as addPanel from '#packages/oldAddPanel';
import section from './live/section2';

export default {
  getCategorySections() {
    const addPanelTextSection = addPanel.sections.getSections().text;
    if (addPanelTextSection.textMaskSection) {
      addPanelTextSection.textMaskSection =
        addPanel.dataUtil.mergeSectionVideos(
          addPanelTextSection.textMaskSection,
          addPanelTextSection.textMaskSectionVideos,
        );
    }

    return addPanel.dataUtil.mergeWithCommonSections(addPanelTextSection, {
      section_1: section,
    });
  },
};
